<template>
	<div class="time-worked-page" v-if="isReady">
		<div class="time-filter-wrap">
			<portal-filter-bar :label="$t('global.filter')">
				<portal-search-field
					v-if="view === 'list'"
					v-model="filter"
					:label="$t('global.filter')"
					:placeholder="$t('global.filter')"
					:clear-label="$t('global.clear')"
					@change="handleFilterChange"
				></portal-search-field>
				<portal-select-field
					v-model="dateFilter"
					:label="$t('global.date')"
					:options="dateOptions"
					@change="handleDateFilterChange"
				></portal-select-field>
			</portal-filter-bar>
		</div>
		<div class="time-worked-content show-scrollbar">
			<timer-event-table
				v-show="view === 'list'"
				:timer-events="timerEvents"
				:filter="filter"
			></timer-event-table>
			<timer-event-charts
				v-if="view === 'reports'"
				:timer-events="timerEvents"
				:earliest="earliest"
				:latest="latest"
			></timer-event-charts>
		</div>
	</div>
</template>

<script>
	import FilterHelpers from '@/utils/FilterHelpers';
	import TimerEventService from '@/modules/timetracking/TimerEventService';
	import TimerEventTable from '@/modules/timetracking/TimerEventTable';
	import TimerEventCharts from '@/modules/timetracking/TimerEventCharts';
	import PortalFilterBar from '@/components/filters/PortalFilterBar';
	import PortalSearchField from '@/components/filters/PortalSearchField';
	import PortalSelectField from '@/components/filters/PortalSelectField';
	import { DateTime } from 'luxon';

	export default {
		name: 'TimerEventList',

		components: {
			TimerEventCharts,
			TimerEventTable,
			PortalFilterBar,
			PortalSearchField,
			PortalSelectField,
		},

    props: ['v'],

		mixins: [],

		data: function() {
			return {
				filter: null,
				dateFilter: null,
				earliest: null,
				latest: null,
				view: 'list',
                isReady: false,
				timerEvents: [],
				timerEventService: new TimerEventService(),

				dateOptions: FilterHelpers.getDateOptions([
					'this-month',
					'last-month',
					'last-last-month',
					'past-60-days',
					'past-90-days',
					'past-6-months',
					'past-12-months',
					'this-year',
					'last-year',
				]),

			};
		},

		mounted() {
      if (this.v) {
        this.view = this.v;
      }

			this.getDateFilter();
			this.getFilter();
			this.init();
		},

		beforeDestroy() {},

		methods: {
      setView: function(view) {
        this.view = view;
        window.history.pushState({}, document.title, this.$router.currentRoute.path + `?v=${view}`);
      },

			init: function(){
				this.setEarliestAndLatest();
				this.getTimerEvents();
			},

			handleFilterChange(event) {
				this.setFilter(event);
			},

			getFilter: function(){
				let filter = sessionStorage.getItem('TIMETRACK_FILTER');
				if (filter) {
					try {
						const parsedFilter = JSON.parse(filter);
						this.filter = typeof parsedFilter === 'string' ? parsedFilter : null;
					} catch (error) {
						sessionStorage.removeItem('TIMETRACK_FILTER');
						this.setFilter(null);
					}
				} else {
					this.setFilter(null);
				}
			},

			setFilter: function(filter = null){
				this.filter = filter;
				sessionStorage.setItem('TIMETRACK_FILTER',JSON.stringify(filter));
			},

			handleDateFilterChange(event) {
				this.setDateFilter(event);
				this.init();
			},

			getDateFilter: function(){
				let dateFilter = localStorage.getItem('TIMETRACK_DATE_FILTER');
				console.log('getFilter');
				if(dateFilter){
					console.log('hello');
					this.dateFilter = JSON.parse(dateFilter);
				}else{
					console.log('setting, yo');
					this.setDateFilter('past-60-days');
				}
			},

			setDateFilter: function(filter){
				this.dateFilter = filter;
				localStorage.setItem('TIMETRACK_DATE_FILTER',JSON.stringify(filter));
			},


			getTimerEvents: function() {
				this.timerEventService.getTimerEvents(this.earliest, this.latest)
					.then((res) => {
						this.timerEvents.splice(0, this.timerEvents.length);
						this.timerEvents.push(...res.data);
						this.timerEvents.forEach(item => {
							item.startDate = DateTime.fromISO(item.timerStart);
              item.endDate = item.startDate.plus({seconds: item.duration});
              item.durationSeconds = item.endDate.diff(item.startDate,['seconds']).seconds;
						});
						this.isReady = true;
					});
			},

			setEarliestAndLatest: function() {
				if (this.dateFilter) {
					let helper = FilterHelpers.getEarliestAndLatest(this.dateFilter, false);
					this.earliest = helper.earliest;
					this.latest = helper.latest;
				} else {
					this.earliest = null;
					this.latest = null;
				}
			},
		},

		watch: {
      v: function(val){
        this.setView(val);
      }
    },

		computed: {
      pages: function() {
        let result = [
              {label: this.$t('timetrack.time-entries.heading'), value: 'list'},
              {label: this.$t('timetrack.reports.heading'), value: 'reports'},
            ];
            return result;
      },
    },
	};
</script>

<style scoped lang="scss">
	.time-worked-page {
		min-height: 100%;
		display: flex;
		flex-direction: column;
	}

	.time-filter-wrap {
		position: sticky;
		z-index: 3;
		top: 0;
		padding: 16px 16px 0;
		background: var(--portal-canvas);
	}

	.time-worked-content {
		min-height: 0;
		flex: 1;
	}

	@media (max-width: 599px) {
		.time-filter-wrap {
			padding: 12px 12px 0;
		}
	}
</style>
